import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core'
import { PdpPublicationsDialogComponent } from '../pdp-publications-dialog/pdp-publications-dialog.component'
import { PdpGalleryService } from '../../../../../shared/services/pdp-gallery.service'
import { MovingImageService } from '../../../../../cms/services/moving-image/moving-image.service'
import { MbConstants } from '../../../../../shared/mb-constants'
import {
  GalleryImageData, MbDatasetEntryType, MbImageDatasetEntry, MbProductTabApplications, MbProductTabApplicationsDataset,
  MbPublicationDatasetEntry, MbVideoDatasetEntry
} from '../../../../../models'
import { MbModalService } from '../../../../../shared/services/modal.service'
import { UcService } from '../../../../../cms/enums/uc-service'
import { Subscription } from 'rxjs'
import { take } from 'rxjs/operators'

@Component({
  selector: 'mb-pdp-application-item',
  templateUrl: './pdp-application-item.component.html',
  styleUrls: ['./pdp-application-item.component.scss']
})
export class PdpApplicationItemComponent implements OnInit, OnDestroy {

  @Input() application: MbProductTabApplications | undefined

  @Input() productName = ''

  maxPublicationsShown = 3
  activeConjugateIndex = 0
  activeConjugateCode = ''
  mbDatasetEntryTypes = MbDatasetEntryType
  thumbnails: GalleryImageData[] = []
  constant = MbConstants
  subscription = new Subscription()

  constructor (private modalService: MbModalService,
               private pdpGalleryService: PdpGalleryService,
               private miService: MovingImageService,
               private cd: ChangeDetectorRef) {
  }

  ngOnInit (): void {
    this.activeConjugateCode = this.getDistinctConjugateCodes()[0] || ''
    this.application?.dataSets?.forEach(dataset => {
      dataset.entries?.forEach(entry => {
        if (entry.type === this.mbDatasetEntryTypes.VIDEO) {
          const videoEntry = entry as MbVideoDatasetEntry
          this.subscription.add(this.miService.getVideoById(videoEntry.videoId)
            .pipe(take(1))
            .subscribe(video => {
              this.thumbnails = [
                {
                  image: video?.stills?.find((still) => still.quality === this.constant.HIGH_RESOLUTION_FORMAT)?.url ?? '',
                  videoId: videoEntry.videoId,
                  legend: dataset.description
                }
              ]
              this.cd.detectChanges()
            }))
        }
      })
    })
  }

  getDistinctConjugateCodes () {
    return Array.from(
      new Set(this.application?.dataSets?.filter(dataSet => !!dataSet && dataSet?.conjugateCode)
        .map(dataSet => dataSet?.conjugateCode)
        .sort())
    )
  }

  getDataSetsOfActiveConjugate () {
    return this.application?.dataSets?.filter((dataSet: any) => dataSet.conjugateCode === this.activeConjugateCode)
  }

  getInformationItems (dataSet: MbProductTabApplicationsDataset | undefined, type: MbDatasetEntryType) {
    return dataSet?.entries?.filter(entry => entry?.type === type)
  }

  setActiveConjugate (index: number, code: string) {
    this.activeConjugateIndex = index
    this.activeConjugateCode = code
  }

  openPublicationsDialog (publications?: MbPublicationDatasetEntry[]) {
    if (!publications) {
      return
    }
    const modalRef = this.modalService.open(PdpPublicationsDialogComponent, {
      centered: true,
      scrollable: true,
      size: 'xl',
      modalDialogClass: 'mb-ng-modal'
    })
    modalRef.componentInstance.publications = publications.map(pub => ({
      name: pub?.key,
      url: pub?.value
    }))
  }

  getThumbnail (videoId: string) {
    return this.pdpGalleryService.getThumbnail(videoId, this.thumbnails)
  }

  ngOnDestroy (): void {
    this.subscription.unsubscribe()
  }

  async openGalleryDialog (activeImage: any,
                           images: MbImageDatasetEntry[],
                           description: string,
                           videos: MbVideoDatasetEntry[]) {
    const dVideos = this.pdpGalleryService.toGalleryImageData(videos, description)
    const dImages = this.pdpGalleryService.toGalleryImageData(images, description)
    try {
      await this.pdpGalleryService.openGalleryDialog({
        activeImage: this.pdpGalleryService.toActiveImageData(activeImage, description),
        position: 'Application',
        gallery: [...dImages, ...dVideos],
        hasApplicationData: true,
        productName: this.productName,
        videoThumbnails: this.thumbnails
      })
    } catch (_) {
    }
  }

  readonly ucService = UcService
}
